// src/View/Others/NotificationSettings.js
import React from 'react';
import NotificationManager from '../../Component/NotificationManager';
import NotificationTest from '../../Component/NotificationTest';
import AuthNotificationDemo from '../../Component/AuthNotificationDemo';

const NotificationSettings = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-10 mx-auto">
          <div className="card">
            <div className="card-header">
              <h4>Notification Settings</h4>
            </div>
            <div className="card-body">
              <NotificationManager />
              
              <hr style={{ margin: '30px 0' }} />
              
              <NotificationTest />
              
              <hr style={{ margin: '30px 0' }} />
              
              <AuthNotificationDemo />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
